import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';

class BlockLinedTitleData {
  title: BlockComponentText;
  url?: BlockComponentImage;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockLinedTitleData {
  export function make(title: string, url?: string): BlockLinedTitleData {
    return {
      title: BlockComponentText.make(title),
      url: BlockComponentImage.make(url),
    };
  }

  export function getDefault(title = 'タイトル'): BlockLinedTitleData {
    return make(`<p><strong style="font-size: 36px;">${title}</strong></p>`);
  }
}

export default BlockLinedTitleData;
